import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';
import {User} from './models/app.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token',
    'accessPrivilegee':  '1'
  })
};

@Injectable({
  providedIn: 'root'
})

export class AppService {

  private baseUrl = 'https://api.cydiacloud.org/';
  //private baseUrl = 'http://localhost:3000/';

  constructor(private _http: HttpClient) { }

  getConfigData(configId: number) {
    return this._http.get(this.baseUrl + 'v1/getconfigurations/' + configId);
  }

  getConfigDataByPage(pageName: string) {
    return this._http.get(this.baseUrl + 'v1/getconfigurationsbypage/' + pageName);
  }

  getContentListByPageName(pageName: string) {
    return this._http.get(this.baseUrl + 'v1/getcontlistbypage/' + pageName);
  }

  getSubContents(contentId: number) {
    return this._http.get(this.baseUrl + 'v1/getsubcontents/' + contentId);
  }

  getContentById(contId: number) {
    return this._http.get(this.baseUrl + 'v1/getcontentbyid/' + contId);
  }

  getRandomAppsHomePage(appPri: string) {
    return this._http.get(this.baseUrl + 'v1/getrandomappshome/' + appPri);
  }

  getRandomAppsHomePageNoAccessPri() {
    return this._http.get(this.baseUrl + 'v1/getrandomappshome');
  }

  getAllAppPrivileges() {
    return this._http.get(this.baseUrl + 'v1/getallappprivileges');
  }

  getTweaksAndExtensions() {
    return this._http.get(this.baseUrl + 'v1/gettweaksandextensions');
  }

  getToolsByExtensions(exId: number) {
    return this._http.get(this.baseUrl + 'v1/viewtoolsbyex/' + exId);
  }

  getAppsByType(appType: number) {
    return this._http.get(this.baseUrl + 'v1/viewappsbytype/' + appType);
  }

  getAppByAppID(appId: number) {
    return this._http.get(this.baseUrl + 'v1/getsingleappdata/' + appId);
  }

  getAllSources() {
    return this._http.get(this.baseUrl + 'v1/getallsources');
  }

  getDownloadCount(appId: number) {
    return this._http.get(this.baseUrl + 'v1/getdownloadcount/' + appId);
  }

  getVersionData(appId: number) {
    return this._http.get(this.baseUrl + 'v1/getversiondata/' + appId);
  }

  getAuthorData(appId: number) {
    return this._http.get(this.baseUrl + 'v1/getauthordata/' + appId);
  }

  getAppImages(appId: number) {
    return this._http.get(this.baseUrl + 'v1/getsingleappimages/' + appId);
  }

  getUserData(userEmail: string) {
    return this._http.post<string>(this.baseUrl + 'v1/getuserdata', {useremail: userEmail}, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getAllAppChanges() {
    return this._http.get(this.baseUrl + 'v1/getappallchanges');
  }

  addDownloadClick(userEmail: string, appId: number, userIdentifier: string) {
    return this._http.post<string>(this.baseUrl + 'v1/adddownloadclick', {useremail: userEmail, appid: appId, useridentifier: userIdentifier}, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  searchApps(key: string) {
    return this._http.post<string>(this.baseUrl + 'v1/searchapps', {key: key}, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  searchSources(key: string) {
    return this._http.post<string>(this.baseUrl + 'v1/searchsources', {key: key}, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getUserInstalledApps(userEmail: string, userIdentifier: string) {
    return this._http.post<string>(this.baseUrl + 'v1/getinstalledapps', {useremail: userEmail, useridentifier: userIdentifier}, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getUserInstalledAppByAppID(userEmail: string, userIdentifier: string, appId: number) {
    return this._http.post<string>(this.baseUrl + 'v1/getinstalledappbyappid', {useremail: userEmail, useridentifier: userIdentifier, appid: appId}, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  updateAddUserData(userData: User): Observable<User> {
    return this._http.post<User>(this.baseUrl + 'v1/addupdateuserdata', userData, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

}

